import { HttpModelConverter } from "src/app/modules/core/converter/httpModel.converter";
import { Injectable } from "@angular/core";
import { MedicalDeviceModel } from "../medicalDevice.model";
import { MedicalDeviceSummaryConverter } from "./medicalDeviceSummary.converter";

@Injectable({
    providedIn: 'root'
})
export class MedicalDeviceConverter extends HttpModelConverter<MedicalDeviceModel> {
    constructor(private deviceSummaryConverter: MedicalDeviceSummaryConverter) {
        super();
    }

    protected createInstance(): MedicalDeviceModel {
        return new MedicalDeviceModel();
    }

    protected enrichObject(result: MedicalDeviceModel, src: MedicalDeviceModel) {
        result.summary = this.deviceSummaryConverter.convert(src.summary);
        // No conversion for primitive types
    }
}

